/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ListCategoryForCompany$Params {
  CompanyId?: string;
}

export function listCategoryForCompany(http: HttpClient, rootUrl: string, params?: ListCategoryForCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, listCategoryForCompany.PATH, 'get');
  if (params) {
    rb.query('CompanyId', params.CompanyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

listCategoryForCompany.PATH = '/api/gmn/Menu/listcategoryforcompany';
